module.exports = __webpack_public_path__ + "static/media/onion-rings.86affa9d.jpg";